export default __webpack_public_path__ + "static/media/tmp_banner_image01.ecf2ce28.png";